export default __webpack_public_path__ + "static/media/2-5-3.d02ca72b.jpg";